import { Component, Input, OnInit } from '@angular/core';
import { SurveysOpinionTaskService } from '../../../services/surveys-opinion-task.service';
import { MatDialog } from '@angular/material/dialog';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { TranslateService } from '@ngx-translate/core';
import { SurveyResponsesFilter } from '../../../models/surveys-tasks/SurveyResponsesFilter';
import { ListModel, SurveyResponsesList } from '../../../models/surveys-tasks/SurveyResponsesList';
import { AmbassadorSurveysTasksAddResponseComponent } from './ambassador-surveys-tasks-add-response/ambassador-surveys-tasks-add-response.component';
import { SurveyTaskDetails } from '../../../models/surveys-tasks/SurveyTaskDetails';
import { SurveysTasksSurveyFormComponent } from '../surveys-tasks-survey-form/surveys-tasks-survey-form.component';
import { SurveyOpinionResposnseStatusEnum } from '../../../models/surveys-tasks/enums/SurveyOpinionResposnseStatusEnum';
import { SurveyResponsesSortEnum } from '../../../models/surveys-tasks/enums/SurveyResponsesSortEnum';

@Component({
  selector: 'app-surveys-tasks-answers-responses',
  standalone: false,
  templateUrl: './surveys-tasks-answers-responses.component.html'
})
export class SurveysTasksAnswersResponsesComponent implements OnInit {
  @Input({ required: true }) details: SurveyTaskDetails;
  @Input({ required: true }) isAmbassador: boolean;
  dataLoading = true;
  loading = false;
  pageNumber = 1;
  pageSize = 6;
  pageCount = 0;
  totalCount = 0;
  sortValue = SurveyResponsesSortEnum.CREATION_DATE_DSC;
  recordsData: ListModel[] = [];
  dataSource: SurveyResponsesList = new SurveyResponsesList();
  filterModel: SurveyResponsesFilter = new SurveyResponsesFilter();
  canAddResponse = false
  SurveyOpinionResposnseStatusEnum = SurveyOpinionResposnseStatusEnum

  selectedIds: string[] = [];
  selectedRecordId: any = null


  constructor(
    private service: SurveysOpinionTaskService,
    public dialog: MatDialog,
    private swalService: SwalService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  getAll(event: any = null) {
    this.filterModel.sort = this.sortValue
    this.filterModel.taskId = this.details.taskId;
    this.dataLoading = !this.loading;
    if (event) {
      this.pageNumber = 1;
    }
    this.filterModel.pageSize = this.pageSize;
    this.filterModel.pageNumber = this.pageNumber;
    this.service.getSurveyResponses(this.filterModel).subscribe(
      (data: SurveyResponsesList) => {
        this.dataLoading = false;
        this.loading = false;
        if (data) {
          this.totalCount = data.totalCount;
          this.canAddResponse = data.canAddResponse
          this.dataSource = data;
          if (this.recordsData && this.recordsData.length && !event) {
            this.recordsData = this.recordsData.concat(data.data);
          } else {
            this.recordsData = data.data as ListModel[];
          }
          this.pageCount = Math.ceil(
            data.totalCount / this.filterModel.pageSize
          );
        }
      },
      (error: any) => {
        this.recordsData = [];
        this.dataLoading = false;
        this.loading = false;
      });
  }

  getNextPage() {
    if (this.pageNumber <= this.pageCount - 1) {
      this.loading = true;
      this.pageNumber += 1;
      this.getAll(null);
    }
  }


  get allSelected(): boolean {
    const selectable = this.recordsData.filter(r => r.canSeletetAllRespondent);
    return selectable.length > 0 && selectable.every(r => this.selectedIds.includes(r.respondentsId));
  }

  get someSelected(): boolean {
    return this.selectedIds.length > 0 && !this.allSelected;
  }

  isSelected(record: ListModel): boolean {
    return this.selectedIds.includes(record.respondentsId);
  }

  toggleOne(record: ListModel, checked: boolean) {
    if (checked) {
      this.selectedIds.push(record.respondentsId);
    } else {
      this.selectedIds = this.selectedIds.filter(id => id !== record.respondentsId);
    }
  }

  toggleAll(checked: boolean) {
    const selectableIds = this.recordsData
      .filter(r => r.canSeletetAllRespondent)
      .map(r => r.respondentsId);

    if (checked) {
      this.selectedIds = Array.from(new Set([...this.selectedIds, ...selectableIds]));
    } else {
      this.selectedIds = this.selectedIds.filter(id => !selectableIds.includes(id));
    }
  }

  excludeSelected() {

  }

  addResponse() {
    const dialogRef = this.dialog.open(AmbassadorSurveysTasksAddResponseComponent, {
      width: '540px',
      data: { details: this.details }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openSurvey(result);
      }
    });
  }
  openSurvey(responseDetails) {
    responseDetails.taskId = this.details.taskId
    const dialogRef = this.dialog.open(SurveysTasksSurveyFormComponent, {
      width: '1200px',
      maxWidth: '1200px',
      data: responseDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.refreshDetails.next(true)
      }
    });
  }

  openDetails(id: any) {
    this.selectedRecordId = id
  }
}
